import SideBarTypes from './constants'

const initialState = {
  requesting: false,
  successful: false,
  messages: [],
  errors: [],
  type: SideBarTypes.INIT,
  data: [] 
}

const reducer = function sidebarReducer (state = initialState, action) {
  switch (action.type) {

    case SideBarTypes.REQUESTING:
      return {
        ...state, // ensure that we don't erase fetched ones
        requesting: false,
        successful: true,
        messages: [],
        errors: [],
        type: action.type,
      }

    case SideBarTypes.SUCCESS:
      const {message, records} = action.payload;
      return {
        ...state, // ensure that we don't erase fetched ones
        data: records, // replace with fresh list
        requesting: false,
        successful: true,
        messages: [{
          body: message,
          time: new Date(),
        }],
        errors: [],
        type: action.type,
      }

    case SideBarTypes.ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        data: [],
        requesting: false,
        successful: false,
        messages: [],
        errors: [{
          body: action.error,
          time: new Date(),
        }],
        type: action.type,
      }
      
    default:
      return state
  }
}

export default reducer;



// WEBPACK FOOTER //
// ./src/components/Sidebar/reducer.js